const Kidsitemss = [
  {
    category: "kids",
    subcategory: "Sandals",
    name: "Sandales d'eau à bout fermé à séchage rapide pour enfants unisexe",
    price: "16.2",
    raw_price: "32.4",
    currency: "USD",
    discount: "50",
    likes_count: "45",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Dark Blue",
    variation_1_color: "Green",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/0C/B7/0d577a41-b4bd-4300-8ae0-f0cbee56f940.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0C/B7/0d577a41-b4bd-4300-8ae0-f0cbee56f940.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/04/7D/11a5df2f-f7f8-4149-956b-27df56c489c9.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/04/7D/11a5df2f-f7f8-4149-956b-27df56c489c9.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F4/F0/a72f7113-7b4a-4677-84f4-d6b4466a40f3.jpg",
    url: "https://fr.newchic.com/sandals-12140/p-1696009.html",
    id: "1696009",
    model: "SKUF46386",
  },
  {
    category: "kids",
    subcategory: "Culottes de grossesse",
    name: "Sous-vêtements de maternité confortables taille haute",
    price: "14.03",
    raw_price: "35.35",
    currency: "USD",
    discount: "60",
    likes_count: "153",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Beige",
    variation_1_color: "Bleu",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/78/04/6f3a6947-2086-4029-92a0-7cca26a1b115.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/78/04/6f3a6947-2086-4029-92a0-7cca26a1b115.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/28/41/e417f071-5385-4f3f-85db-338d7798f433.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/28/41/e417f071-5385-4f3f-85db-338d7798f433.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B9/7F/7f7a5269-b3bf-4918-ae85-71db38fa26fb.jpg",
    url: "https://fr.newchic.com/maternity-panties-4853/p-1320317.html",
    id: "1320317",
    model: "SKU983263",
  },
  {
    category: "kids",
    subcategory: "Sandals",
    name:
      "Unisexe Kids Comfy antidérapant jardin chaussures de sabot d'eau de jardin",
    price: "6.99",
    raw_price: "13",
    currency: "USD",
    discount: "46",
    likes_count: "60",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Yellow",
    variation_1_color: "Green",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6B/72/a263aa08-fa67-419d-af16-20d9a58981c8.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6B/72/a263aa08-fa67-419d-af16-20d9a58981c8.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F3/B6/c28b4231-ca94-4d0b-8129-b2220625378b.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F3/B6/c28b4231-ca94-4d0b-8129-b2220625378b.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/75/34/6802aef2-ca27-43c3-916e-9e1b247c74db.jpg",
    url: "https://fr.newchic.com/sandals-12132/p-1693907.html",
    id: "1693907",
    model: "SKUF43614",
  },
  {
    category: "kids",
    subcategory: "Chaussures pour garçon",
    name: "Sandales de plage légères pour garçon",
    price: "12.45",
    raw_price: "22",
    currency: "USD",
    discount: "43",
    likes_count: "158",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "vert",
    variation_1_color: "Bleu",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/89/C8/79224db0-9fc5-4786-953f-2daa8779e71f.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/89/C8/79224db0-9fc5-4786-953f-2daa8779e71f.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/3A/43/0912dfd6-30f4-4e52-9ca1-fd3e4d669c7d.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/3A/43/0912dfd6-30f4-4e52-9ca1-fd3e4d669c7d.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CA/7E/a18ba779-63c0-433b-b1fa-5ea22e10d7e0.jpg",
    url: "https://fr.newchic.com/boys-shoes-4572/p-1449419.html",
    id: "1449419",
    model: "SKUB67845",
  },
  {
    category: "kids",
    subcategory: "Robes",
    name: "Robe fille licorne papillon pour 4-13 ans",
    price: "9.99",
    raw_price: "26.99",
    currency: "USD",
    discount: "63",
    likes_count: "914",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Rose",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/05/C4/a712cff5-30b9-4c9a-bc41-b4bf7d6c4138.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/05/C4/a712cff5-30b9-4c9a-bc41-b4bf7d6c4138.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/80/DA/5205db8e-b7c6-4e96-b918-52ef76d5eb38.jpg",
    url: "https://fr.newchic.com/dresses-4670/p-1441888.html",
    id: "1441888",
    model: "SKUB61343",
  },
  {
    category: "kids",
    subcategory: "Robes",
    name:
      "Girls Unicorn Rainbow Stripe Print Short-sleeved Casual Dress For 3-8Y",
    price: "19.99",
    raw_price: "39.98",
    currency: "USD",
    discount: "50",
    likes_count: "42",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Pink",
    variation_1_color: "Gray",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/88/2E/23173447-d226-4818-b47a-fd30ec59fbae.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/88/2E/23173447-d226-4818-b47a-fd30ec59fbae.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/60/DA/94bb0c44-42b4-48a8-9118-e23aaff6bda1.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/60/DA/94bb0c44-42b4-48a8-9118-e23aaff6bda1.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/70/AC/cf8ca027-113c-4471-9ec2-3766468ee7af.jpg",
    url: "https://fr.newchic.com/dresses-4670/p-1678233.html",
    id: "1678233",
    model: "SKUF15571",
  },
  {
    category: "kids",
    subcategory: "Brassières de grossesse",
    name: "Soutien-gorge d'allaitement sans fil anti-affaissement en dentelle",
    price: "10.02",
    raw_price: "25.25",
    currency: "USD",
    discount: "60",
    likes_count: "1220",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "Rose",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A6/8D/cc5b7067-e9a4-44cd-9fe6-a78a73855a21.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A6/8D/cc5b7067-e9a4-44cd-9fe6-a78a73855a21.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B0/B6/07e6204c-7652-4699-bf3e-bd5870bb9b15.JPG",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B0/B6/07e6204c-7652-4699-bf3e-bd5870bb9b15.JPG",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CB/47/b00a9774-89bc-40f1-ac58-18556aa40c35.jpg",
    url: "https://fr.newchic.com/maternity-bra-4855/p-1474362.html",
    id: "1474362",
    model: "SKUB95625",
  },
  {
    category: "kids",
    subcategory: "Pantalons & Jupes",
    name: "Jeans brodé chat fille pour 3-15 ans",
    price: "18.04",
    raw_price: "45.46",
    currency: "USD",
    discount: "60",
    likes_count: "670",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "1",
    variation_1_color: "2",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6D/41/3c62feb9-8c51-415f-a63f-07d7ed9cab8a.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6D/41/3c62feb9-8c51-415f-a63f-07d7ed9cab8a.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/35/BB/e7f98b60-9e60-4d30-b014-8a87f5336bd3.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/35/BB/e7f98b60-9e60-4d30-b014-8a87f5336bd3.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/A1/FE/8e5fa441-4875-4ae4-a57e-ab9010b8378b.png",
    url: "https://fr.newchic.com/girls-bottoms-4671/p-1499924.html",
    id: "1499924",
    model: "SKUC20097",
  },
  {
    category: "kids",
    subcategory: "Costumes pour bébé",
    name: "18pcs nouveau-né baby shower coffret pour 0-6m",
    price: "45.12",
    raw_price: "113.7",
    currency: "USD",
    discount: "60",
    likes_count: "350",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Jaune",
    variation_1_color: "Rose",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/34/1F/ee5a5fc1-97a7-4045-adc1-47620434386c.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/34/1F/ee5a5fc1-97a7-4045-adc1-47620434386c.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/15/5C/c8e732ac-326f-4e87-a86d-ba82dbd21988.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/15/5C/c8e732ac-326f-4e87-a86d-ba82dbd21988.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C4/1C/78d9d643-9016-4f8d-bac6-9429ca92684b.jpg",
    url: "https://fr.newchic.com/baby-sets-6251/p-1339676.html",
    id: "1339676",
    model: "SKUA11498",
  },
  {
    category: "kids",
    subcategory: "Pantalons & Jupes",
    name: "Combinaison dos nu fille pour 3Y-11Y",
    price: "20.05",
    raw_price: "50.52",
    currency: "USD",
    discount: "60",
    likes_count: "686",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Gris foncé",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/63/F8/0cf499db-3ee8-4f00-9a11-384053e7938a.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/63/F8/0cf499db-3ee8-4f00-9a11-384053e7938a.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/82/DF/ba8e4236-58a1-48dd-b9f0-b19033e45c8b.jpg",
    url: "https://fr.newchic.com/girls-bottoms-4671/p-1277757.html",
    id: "1277757",
    model: "SKU908275",
  },
  {
    category: "kids",
    subcategory: "Brassières de grossesse",
    name: "Brassière de grossesse en couleur pure",
    price: "15.03",
    raw_price: "37.88",
    currency: "USD",
    discount: "60",
    likes_count: "318",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Rose",
    variation_1_color: "Beige",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/EE/D6/33c336b7-9b75-4ef2-9e93-dbad349f5a66.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/EE/D6/33c336b7-9b75-4ef2-9e93-dbad349f5a66.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/93/AE/a54eb549-a75f-46fe-84bc-526ab50ea4e1.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/93/AE/a54eb549-a75f-46fe-84bc-526ab50ea4e1.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/11/EF/b4f2b033-c426-41c2-9b2d-d07b371e943b.jpg",
    url: "https://fr.newchic.com/maternity-bra-4855/p-1315172.html",
    id: "1315172",
    model: "SKU979783",
  },
  {
    category: "kids",
    subcategory: "Pantalons & Jupes",
    name: "Combinaison à fleurs Bohème pour filles",
    price: "24.06",
    raw_price: "60.63",
    currency: "USD",
    discount: "60",
    likes_count: "667",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Orange",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6F/0A/98109920-bc9a-4d12-a4b2-7c6d0970cbb6.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6F/0A/98109920-bc9a-4d12-a4b2-7c6d0970cbb6.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/90/A7/b5ea36fb-c124-496c-89dd-933d12d51625.jpg",

    url: "https://fr.newchic.com/girls-bottoms-4671/p-1300717.html",
    id: "1300717",
    model: "SKU932518",
  },
  {
    category: "kids",
    subcategory: "Robes",
    name: "Robe de fleur de princesse fille 2PCs pour 1-7Y",
    price: "32.09",
    raw_price: "80.84",
    currency: "USD",
    discount: "60",
    likes_count: "171",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue",
    variation_1_color: "Wine Red",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/72/AF/3bc544a2-0929-460d-bd26-37e0b8aad31a.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/72/AF/3bc544a2-0929-460d-bd26-37e0b8aad31a.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/90/A7/b5ea36fb-c124-496c-89dd-933d12d51625.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/90/A7/b5ea36fb-c124-496c-89dd-933d12d51625.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BD/88/25e71953-9af2-4ff6-a353-8b308d12802e.jpg",
    url: "https://fr.newchic.com/dresses-4670/p-1624942.html",
    id: "1624942",
    model: "SKUE26603",
  },
  {
    category: "kids",
    subcategory: "Robes",
    name: "Filles Robe Grise Plissée Pour 4Y-15Y",
    price: "49.14",
    raw_price: "123.8",
    currency: "USD",
    discount: "60",
    likes_count: "752",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Rose",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BD/88/25e71953-9af2-4ff6-a353-8b308d12802e.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BD/88/25e71953-9af2-4ff6-a353-8b308d12802e.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/26/10/117b0972-0658-453f-a141-3b059c9e4c1d.jpg",
    url: "https://fr.newchic.com/dresses-4670/p-1347579.html",
    id: "1347579",
    model: "SKUA25498",
  },
  {
    category: "kids",
    subcategory: "Robes",
    name: "Filles Sling Sun Print Dress mignon pour 2-9Y",
    price: "15.03",
    raw_price: "37.88",
    currency: "USD",
    discount: "60",
    likes_count: "263",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Yellow",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/18/03/0c6e99b1-c67d-43bb-9cc5-7f6422e09cc9.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/18/03/0c6e99b1-c67d-43bb-9cc5-7f6422e09cc9.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/05/B5/e9d63ee4-cb58-410b-a5ed-d78eaf496071.jpg",
    url: "https://fr.newchic.com/dresses-4670/p-1525806.html",
    id: "1525806",
    model: "SKUC77175",
  },
  {
    category: "kids",
    subcategory: "Robes",
    name: "Robe mère-fille fleurie assortie",
    price: "23.99",
    raw_price: "39.99",
    currency: "USD",
    discount: "40",
    likes_count: "104",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image: "",

    variation_1_thumbnail: "",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/90/A7/b5ea36fb-c124-496c-89dd-933d12d51625.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/05/B5/e9d63ee4-cb58-410b-a5ed-d78eaf496071.jpg",
    url: "https://fr.newchic.com/dresses-4670/p-1365953.html",
    id: "1365953",
    model: "SKUA43605",
  },
  {
    category: "kids",
    subcategory: "Salopettes & Combinaisons",
    name: "Barboteuses d'impression de bande dessinée de bébé pour 0-18M",
    price: "18.04",
    raw_price: "45.46",
    currency: "USD",
    discount: "60",
    likes_count: "89",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#01",
    variation_1_color: "#02",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/04/A5/de2b0bf3-06d4-47ee-866d-62866033e182.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/04/A5/de2b0bf3-06d4-47ee-866d-62866033e182.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/44/4A/fa13a919-40cc-4f3d-81dc-0e044e1011c3.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/44/4A/fa13a919-40cc-4f3d-81dc-0e044e1011c3.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/28/9D/decbd813-c0ee-40bd-bfc3-cca29559e09d.jpg",
    url: "https://fr.newchic.com/rompers-and-bodysuits-4702/p-1604676.html",
    id: "1604676",
    model: "SKUE11599",
  },
  {
    category: "kids",
    subcategory: "Pantalons & Jupes",
    name: "Combinaisons Dot Design Girls pour 2Y-11Y",
    price: "26.07",
    raw_price: "65.68",
    currency: "USD",
    discount: "60",
    likes_count: "1045",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F2/1E/47eb2ecc-8d7e-4414-9658-00a7a8d4c4f9.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F2/1E/47eb2ecc-8d7e-4414-9658-00a7a8d4c4f9.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6C/20/17ae0180-48e8-4d12-9485-8846486e1f8b.jpg",
    url: "https://fr.newchic.com/girls-bottoms-4671/p-1281655.html",
    id: "1281655",
    model: "SKU904030",
  },
  {
    category: "kids",
    subcategory: "Maillots de bain",
    name: "Ensemble de maillots de bain 3 pièces pour fille de 4ans - 13ans",
    price: "24.06",
    raw_price: "60.63",
    currency: "USD",
    discount: "60",
    likes_count: "429",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Bleu ciel",
    variation_1_color: "vert",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/83/47/cf92553b-f75d-4c67-8a2f-09f468b7b5ec.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/83/47/cf92553b-f75d-4c67-8a2f-09f468b7b5ec.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A0/6B/0f90028c-604b-4977-9e60-d6472afcdf7e.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A0/6B/0f90028c-604b-4977-9e60-d6472afcdf7e.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/04/DD/24b24e9c-39c7-4620-94dd-c4f91be6d653.jpg",
    url: "https://fr.newchic.com/girls-swimwear-5242/p-1333626.html",
    id: "1333626",
    model: "SKUA09758",
  },
  {
    category: "kids",
    subcategory: "Coutumes & Co-ords",
    name: "Ensembles de vêtements pour tout-petits garçons pour 3-11 ans",
    price: "23.06",
    raw_price: "58.1",
    currency: "USD",
    discount: "60",
    likes_count: "531",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6C/77/ce307051-d9c5-49f2-8d8e-67e0047e63bb.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6C/77/ce307051-d9c5-49f2-8d8e-67e0047e63bb.jpeg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/EF/9E/50bd5196-e6c6-4501-98a6-7e0a663840fb.jpg",
    url: "https://fr.newchic.com/boys-clothing-set-4935/p-1279496.html",
    id: "1279496",
    model: "SKU847229",
  },
  {
    category: "kids",
    subcategory: "Tops & T-shirt",
    name: "T-shirt garçon imprimé crocodile pour 2-8 ans",
    price: "9.49",
    raw_price: "18.98",
    currency: "USD",
    discount: "50",
    likes_count: "30",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Dark Blue",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B7/92/f811284a-b5cc-408d-aec8-72da285ea60d.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B7/92/f811284a-b5cc-408d-aec8-72da285ea60d.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/04/AE/f02bc82b-4e55-4698-94e0-e04ee0ad7ae1.jpg",
    url: "https://fr.newchic.com/kids-tops-and-t-shirt-4606/p-1664939.html",
    id: "1664939",
    model: "SKUE90466",
  },
  {
    category: "kids",
    subcategory: "Brassières de grossesse",
    name: "Brassière de grossesse en coton souple respirante",
    price: "14.03",
    raw_price: "35.35",
    currency: "USD",
    discount: "60",
    likes_count: "1161",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Grey1",
    variation_1_color: "Coffee",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A2/11/68501721-cd76-4f81-8b43-de52f7d4c629.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A2/11/68501721-cd76-4f81-8b43-de52f7d4c629.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B1/A9/20890982-4304-4509-8447-1abe393b1430.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B1/A9/20890982-4304-4509-8447-1abe393b1430.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/04/AE/f02bc82b-4e55-4698-94e0-e04ee0ad7ae1.jpg",
    url: "https://fr.newchic.com/maternity-bra-4855/p-1358567.html",
    id: "1358567",
    model: "SKUA40764",
  },
  {
    category: "kids",
    subcategory: "Robes",
    name: "Robe de princesse fille licorne pour 3-13 ans",
    price: "29.08",
    raw_price: "73.26",
    currency: "USD",
    discount: "60",
    likes_count: "977",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Jaune",
    variation_1_color: "Violet",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/DF/17/7237c535-a079-4827-9d60-bdaeb36e7612.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DF/17/7237c535-a079-4827-9d60-bdaeb36e7612.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/2A/CF/0db94595-de68-468e-8e9a-db33a6079a7f.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2A/CF/0db94595-de68-468e-8e9a-db33a6079a7f.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/18/FE/aa09dd74-068e-4083-8ab8-dc9030eee606.jpg",
    url: "https://fr.newchic.com/dresses-4670/p-1448500.html",
    id: "1448500",
    model: "SKUB66991",
  },
  {
    category: "kids",
    subcategory: "Tops & T-shirt",
    name: "T-shirt d'été pour garçon dinosaure pour 2-10 ans",
    price: "11.52",
    raw_price: "29.04",
    currency: "USD",
    discount: "60",
    likes_count: "44",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/18/FE/aa09dd74-068e-4083-8ab8-dc9030eee606.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/18/FE/aa09dd74-068e-4083-8ab8-dc9030eee606.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/96/55/10dcd6bc-21ff-497d-a693-5970a28d1083.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/96/55/10dcd6bc-21ff-497d-a693-5970a28d1083.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A8/B1/b53622a9-21d5-40db-a723-fd50253ed416.jpeg",
    url: "https://fr.newchic.com/kids-tops-and-t-shirt-4606/p-1664940.html",
    id: "1664940",
    model: "SKUE90499",
  },
  {
    category: "kids",
    subcategory: "Costume & Jupe-culotte",
    name: "Ensemble d'impression de tournesol pour fille pour 1-7 ans",
    price: "18.49",
    raw_price: "36.98",
    currency: "USD",
    discount: "50",
    likes_count: "73",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Yellow",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/8F/AC/4c759553-1fad-4b82-929b-d2735a7f17df.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A8/B1/b53622a9-21d5-40db-a723-fd50253ed416.jpeg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/8F/AC/4c759553-1fad-4b82-929b-d2735a7f17df.jpg",
    url: "https://fr.newchic.com/girls-clothing-sets-4934/p-1674344.html",
    id: "1674344",
    model: "SKUF10459",
  },
  {
    category: "kids",
    subcategory: "Pyjamas",
    name: "Pyjama rayé dinosaure garçon pour 1 à 7 ans",
    price: "17.49",
    raw_price: "34.98",
    currency: "USD",
    discount: "50",
    likes_count: "29",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Gray",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/DD/7A/662ea2a9-0bb1-42f7-9e1b-ad97d108b8e8.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A8/B1/b53622a9-21d5-40db-a723-fd50253ed416.jpeg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DD/7A/662ea2a9-0bb1-42f7-9e1b-ad97d108b8e8.jpg",
    url: "https://fr.newchic.com/pajamas-6169/p-1662735.html",
    id: "1662735",
    model: "SKUE94071",
  },
  {
    category: "kids",
    subcategory: "Robes",
    name: "Robe pour fille de 2-8 ans",
    price: "28.07",
    raw_price: "70.73",
    currency: "USD",
    discount: "60",
    likes_count: "602",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "blanc",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A8/B1/b53622a9-21d5-40db-a723-fd50253ed416.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/35/1D/f3436359-7cd6-466e-a5aa-41d8587e8c94.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A8/B1/b53622a9-21d5-40db-a723-fd50253ed416.jpeg",
    url: "https://fr.newchic.com/dresses-4670/p-1268210.html",
    id: "1268210",
    model: "SKU890651",
  },
  {
    category: "kids",
    subcategory: "Flats & Loafers",
    name:
      "Unisexe Enfants Comfy Respirant Soft Semelle Décontractée Slip On Chaussures Plates",
    price: "18",
    raw_price: "40.99",
    currency: "USD",
    discount: "56",
    likes_count: "20",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "Red",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/35/1D/f3436359-7cd6-466e-a5aa-41d8587e8c94.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/35/1D/f3436359-7cd6-466e-a5aa-41d8587e8c94.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/82/0C/d36837d3-0426-48e8-8f14-7ab6b94289cd.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/82/0C/d36837d3-0426-48e8-8f14-7ab6b94289cd.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B9/92/48d2c82a-983c-4100-a810-0ab5f32fa474.jpg",
    url: "https://fr.newchic.com/flats-and-loafers-12120/p-1694703.html",
    id: "1694703",
    model: "SKUF43907",
  },
  {
    category: "kids",
    subcategory: "Robes",
    name: "Robe à bretelles Flower Girl pour 1 à 7 ans",
    price: "20.05",
    raw_price: "50.52",
    currency: "USD",
    discount: "60",
    likes_count: "327",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "rouge",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6C/03/82dfd16a-685a-405d-a84e-542ec09fab1d.JPG",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6C/03/82dfd16a-685a-405d-a84e-542ec09fab1d.JPG",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C4/EC/b526836a-69cb-4e81-8770-54903e0c3d23.jpg",
    url: "https://fr.newchic.com/dresses-4670/p-1447479.html",
    id: "1447479",
    model: "SKUB67023",
  },
  {
    category: "kids",
    subcategory: "Sandals",
    name: "Unisexe Kids Classic Tie-Dye Hole Garden Water Clog Shoes",
    price: "12.42",
    raw_price: "23.84",
    currency: "USD",
    discount: "48",
    likes_count: "9",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Pink",
    variation_1_color: "White",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/26/C4/ff5804cc-9866-4fbf-a0ac-bd9c633dc8aa.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/26/C4/ff5804cc-9866-4fbf-a0ac-bd9c633dc8aa.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/18/9E/c7bbd5ae-5d54-4259-b3b2-1be51aaeecce.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/18/9E/c7bbd5ae-5d54-4259-b3b2-1be51aaeecce.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/58/0A/e801e7a2-2b52-4e6b-b2c4-0271d45192d1.jpg",
    url: "https://fr.newchic.com/sandals-12132/p-1704681.html",
    id: "1704681",
    model: "SKUF59760",
  },
  {
    category: "kids",
    subcategory: "Brassières de grossesse",
    name: "Soutien-gorge d'allaitement maternité boutonné devant",
    price: "19.05",
    raw_price: "47.99",
    currency: "USD",
    discount: "60",
    likes_count: "333",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Pink",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/45/87/45e29575-4f80-47e7-84fe-d3b4461e55ad.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/45/87/45e29575-4f80-47e7-84fe-d3b4461e55ad.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/1D/A2/7a6e3eb0-c163-4464-a912-5e9486f4f97f.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/1D/A2/7a6e3eb0-c163-4464-a912-5e9486f4f97f.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/69/EF/576ae464-457c-471f-b69d-a47b4f870471.jpg",
    url: "https://fr.newchic.com/maternity-bra-4855/p-1573105.html",
    id: "1573105",
    model: "SKUD61239",
  },
  {
    category: "kids",
    subcategory: "Costume & Jupe-culotte",
    name: "Ensemble gilet et pantalon à volants pour fille pour 1-7 ans",
    price: "18.55",
    raw_price: "36.98",
    currency: "USD",
    discount: "50",
    likes_count: "91",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D8/6E/475d5c13-b4e7-472f-b7d8-bf345eb1aaa2.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D8/6E/475d5c13-b4e7-472f-b7d8-bf345eb1aaa2.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/57/B6/e99ed24e-edf5-4852-b064-359c350773f1.JPG",
    url: "https://fr.newchic.com/girls-clothing-sets-4934/p-1663289.html",
    id: "1663289",
    model: "SKUE96976",
  },
  {
    category: "kids",
    subcategory: "Brassières de grossesse",
    name: "Soutien-gorge d'allaitement maternité confortable",
    price: "14.03",
    raw_price: "35.35",
    currency: "USD",
    discount: "60",
    likes_count: "325",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Rose",
    variation_1_color: "Nu",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D8/6E/475d5c13-b4e7-472f-b7d8-bf345eb1aaa2.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9C/A5/1996e026-7288-4be8-aa7d-2086f6bbe4a4.JPG",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/57/B6/e99ed24e-edf5-4852-b064-359c350773f1.JPG",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/57/B6/e99ed24e-edf5-4852-b064-359c350773f1.JPG",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/66/41/7e962a05-9c75-438f-b265-f943b97f2c28.jpg",
    url: "https://fr.newchic.com/maternity-bra-4855/p-1443170.html",
    id: "1443170",
    model: "SKUB31232",
  },
  {
    category: "kids",
    subcategory: "Salopettes & Combinaisons",
    name: "Gigoteuse chaude et velours pour 0-24M",
    price: "21.05",
    raw_price: "53.04",
    currency: "USD",
    discount: "60",
    likes_count: "318",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/66/41/7e962a05-9c75-438f-b265-f943b97f2c28.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/66/41/7e962a05-9c75-438f-b265-f943b97f2c28.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9C/79/29cf0ec8-56f3-4ff2-ab21-ef1c023e00d1.jpg",
    url: "https://fr.newchic.com/rompers-and-bodysuits-4702/p-1527773.html",
    id: "1527773",
    model: "SKUC77151",
  },
  {
    category: "kids",
    subcategory: "Robes",
    name: "Soft Robe de fillette en coton 2Y-11Y",
    price: "27.07",
    raw_price: "68.21",
    currency: "USD",
    discount: "60",
    likes_count: "416",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "gris",
    variation_1_color: "Marine",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/E4/3F/a5d2975e-7682-4f3b-8622-0eaed354e6fd.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E4/3F/a5d2975e-7682-4f3b-8622-0eaed354e6fd.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/26/E0/3a8ccd61-46db-4b68-8e22-8593cf1f7b51.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/E4/3F/a5d2975e-7682-4f3b-8622-0eaed354e6fd.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/26/E0/3a8ccd61-46db-4b68-8e22-8593cf1f7b51.jpg",
    url: "https://fr.newchic.com/dresses-4670/p-1308299.html",
    id: "1308299",
    model: "SKU963384",
  },
  {
    category: "kids",
    subcategory: "Chaussures pour garçon",
    name: "Chaussures causales à boucles à crochets respirantes unisexe",
    price: "30.49",
    raw_price: "51.12",
    currency: "USD",
    discount: "40",
    likes_count: "442",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Bleu foncé",
    variation_1_color: "rouge",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F3/83/8be11bef-6c91-4ce9-a7c0-4bfef9432c16.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F3/83/8be11bef-6c91-4ce9-a7c0-4bfef9432c16.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/EC/8A/02f7437e-0504-44ea-a2aa-df10c5d8f7c1.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/EC/8A/02f7437e-0504-44ea-a2aa-df10c5d8f7c1.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2E/17/cc190f21-e64e-4070-b813-f0657a7448d6.jpg",
    url: "https://fr.newchic.com/boys-shoes-4572/p-1364081.html",
    id: "1364081",
    model: "SKUA52294",
  },
  {
    category: "kids",
    subcategory: "Blousons & Vestes",
    name: "Veste de forage imprimée en denim pour fille de 1 à 15 ans",
    price: "30.08",
    raw_price: "75.79",
    currency: "USD",
    discount: "60",
    likes_count: "232",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Dark Blue",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/34/AC/a8d3700e-f57e-41f5-a3d7-7989472f0576.png",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/34/AC/a8d3700e-f57e-41f5-a3d7-7989472f0576.png",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/01/09/fc8defde-775e-44ac-bba6-9c68b17915ca.jpg",

    url: "https://fr.newchic.com/girls-outerwear-and-coats-4672/p-1540202.html",
    id: "1540202",
    model: "SKUD06395",
  },
];

export default Kidsitemss;
